import { render } from "./EdgeDetectPage.vue?vue&type=template&id=25099668"
import script from "./EdgeDetectPage.vue?vue&type=script&lang=js"
export * from "./EdgeDetectPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__